module.exports = __webpack_public_path__ + "static/media/create-alert.555ced1f.gif";